import type { NetworkClient } from './NetworkClient';
import type { NetworkMessage, NetworkMessageHandler } from './NetworkMessage';

export class NullNetworkClient implements NetworkClient {
  async connect(): Promise<void> {}
  disconnect(): void {}
  send(_message: NetworkMessage): void {}
  onMessage(_handler: NetworkMessageHandler): () => void {
    return () => {};
  }
  isConnected(): boolean {
    return false;
  }
}
